import * as types from "../types";
//import AppDataService from "../../services/AppData.Service";
import {
  setAppContent,
  setCardListContent,
  setErrorCodeVerbiage,
  setOccupationContent,
} from "../../shared/AppContent";
import { simplifyJson } from "../../shared/utility";
import Dbfunctions from "../../PouchDb/Pouchdb";
import EncrDecrService from "../../services/EncrDecrService.Service";

const appInit = {
  isSaved: false,
  currentAction: "",
  isSubmited: false,
  isSubmitedSuccess: false,
  screenName: "",
  loading: false,
  error: null,
  splashLoader: true,
  isUserRetrieve: false,
  isSprintTrackRetrieve: false,
  onSd2SuccTelOptSndFail: false
};
// eslint-disable-next-line no-unused-vars
let payload = {};
// eslint-disable-next-line no-unused-vars
let errorState = {};

export const setError = (error) => ({
  type: types.VIEW_ERROR,
  error,
});
export const splashScreen = (value) => ({
  type: types.SPLASH_VAL_TIMER,
  value,
});

export const loadingViewStart = (value) => ({
  type: types.LOADING_VIEW_STATE,
  value,
});

export const funcUpdateCurrentAppState =
  (currentAction, screenName) => (dispatch) => {
    try {
      dispatch({
        type: types.UPDATE_CURRENT_APP_STATE,
        payload: {
          ...appInit,
          currentAction: currentAction,
          screenName: screenName,
        },
      });
    } catch (err) {
      dispatch({
        type: types.UPDATE_CURRENT_APP_STATE,
        payload: {
          ...appInit,
          currentAction: currentAction,
          screenName: screenName,
          error: "Error updating current app state",
        },
      });
    }
  };

export const funcGetSelectedCardData = (cardListContent, cardType, cardKey) => async (dispatch) => {
  const requiredCard = cardListContent.filter((card) => {
    return card[cardKey].toLowerCase() === cardType.toLowerCase();
  });

  dispatch({
    type: types.SET_SELECTED_CARD_DETAILS,
    payload: { selectedCard: requiredCard[0] },
  });
}

export const fetchAppContent = () => async (dispatch) => {

  var response;
  var res = await Dbfunctions.GetState(types.LOCAL_CONTENT_SET)
  if (res._rev) {

    response = res?.response
  } else {

    await fetch(window.global.config?.GetContentEnc)
    .then((r) => r.text())
    .then(text  => {
     response = JSON.parse(EncrDecrService.get(text));
     response?.statusCode === "000" && Dbfunctions.CreateState({ _id: types.LOCAL_CONTENT_SET, response })
    })  
  }
  if (response && response.data) {
     if (response.statusCode === "000") {
      const content = response?.data?.root?.content;
      if (content && setAppContent(content)) {
        simplifyJson(content);
        
        dispatch({
          type: types.SET_APP_CONTENT,
          payload: content,
        });
      }
      const occupationContent = response?.data?.root?.occupationValues;
      if (occupationContent && setOccupationContent(occupationContent)) {
        simplifyJson(occupationContent);
        dispatch({
          type: types.SET_OCC_CONTENT,
          payload: occupationContent,
        });
      }
      const cardListContent = response?.data?.root?.cardData?.card;
      const bannerContent = response?.data?.root?.content?.happy_to_help_banners;

      //if (cardListContent && setCardListContent(cardListContent) && cardTypeData) {
      if (cardListContent && setCardListContent(cardListContent)) {
        simplifyJson(cardListContent);
        // const requiredCard = cardListContent.filter((card) => {
        //   return card.uniqueIdentifier === cardTypeData;
        // });
        dispatch({
          type: types.SET_CND_CONTENT,
          payload: { cardList: cardListContent, bannerContent: bannerContent ? bannerContent : null },
        });
      }

      const errorCodeVerbiage =
        response?.data?.root?.errorCodeVerbiage;
      if (errorCodeVerbiage && setErrorCodeVerbiage(errorCodeVerbiage)) {
        simplifyJson(errorCodeVerbiage);
        dispatch({
          type: types.SET_ERR_CONTENT,
          payload: errorCodeVerbiage,
        });
      } else {
        dispatch(setError("Error fetching app content..."));
      }
      dispatch({
        type: types.APP_BOOT_STATUS,
        payload: { isContent: true }
      })
      funcSetBootAppFlag(dispatch, false);
    } else {
      dispatch({
        type: types.SAVE_VAL_ERROR,
        payload: {
          errorCode: response.statusCode,
          errorMsg: response.message || null,
        }
      });
      funcSetBootAppFlag(dispatch, true);
    }
  } else {
    payload = {
      ...appInit,
      isSubmited: true,
      // loading: false,
      error: response?.message,
    };
    funcSetBootAppFlag(dispatch, true);
  }
  return response?.statusCode;
  // dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};

export const funcUpdateAppStateAfterResponse =
  (appState, errorState) => async (dispatch) => {
    try {
      dispatch({
        type: types.UPDATE_CURRENT_APP_STATE,
        payload: {
          isSaved: appState.isSaved,
          currentAction: appState.currentAction,
          isSubmited: appState.isSubmited,
          isSubmitedSuccess: appState.isSubmitedSuccess,
          screenName: appState?.screenName,
          loading: appState.loading,
          error: appState.error,
          isUserRetrieve: appState.isUserRetrieve,
          isSprintTrackRetrieve: appState.isSprintTrackRetrieve,
		  onSd2SuccTelOptSndFail: appState.onSd2SuccTelOptSndFail,
        },
      });
      // if (errorState && errorState?.errorCode !== "undefined") {
      dispatch({
        type: types.SAVE_VAL_ERROR,
        payload: errorState?.errorCode ? {
          errorCode: errorState.errorCode,
          errorMsg: errorState?.errorMsg || null,
        } : null,
      });
      // }
    } catch (err) {
      dispatch({
        type: types.UPDATE_CURRENT_APP_STATE,
        payload: {
          ...appInit,
          currentAction: appState.currentAction,
          screenName: appState.screenName,
          error: {
            errorCode: "10001",
            errorMsg: "Error updating current app state " + err,
          },
        },
      });
    }
  };

export const funcHandleGenericError = (isGenericError, handleClick, exitEvent, errorMessage) => async (dispatch) => {
  dispatch({
    type: types.GENERIC_ERROR,
    payload: { isGenericError, handleClick, exitEvent, errorMessage },
  });
}

export const funcSetBootAppFlag = (dispatch, value) => {
  dispatch({
    type: types.SET_BOOT_APP_ERROR,
    payload: value
  })
}

export const setAppBootLoader = (value) => async (dispatch) => {
  dispatch({
    type: types.LOADING_APP_STATE,
    payload: value
  })
}

// export const funcSetRetrieveFlag = (value, clickEvent) => async (dispatch) => {
//   dispatch({
//     type: 'RETRIEVE_AGAIN_FLAG',
//     payload: { value, clickEvent },
//   });
// }

export const setWebCamStatus = (value) => (dispatch) => {
  dispatch({
    type: types.SET_WEBCAM_STATUS,
    payload: value
  })
}

export const funcSetWIPStatusCode = (value) => (dispatch) => {
  dispatch({
    type: types.SET_WIP_STATUS,
    payload: value
  })
}